












































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { Contact } from '@/business/message/models/contact'
import { isBlank, isNotBlank } from '@/shared/utils/is-blank'
import ContactItem from '@/business/message/components/contact-item.vue'
import { Key } from 'ts-key-enum'
import { Injector } from '@/config/dependency-injection'
import { RouterToken } from '@/config/injection-tokens'
import { VueRouter } from 'vue-router/types/router'
import UnifyButton from '@/shared/components/unify/unify-button.vue'

@Component({
  components: { UnifyButton, ContactItem },
})
export default class ContactList extends Vue {
  @Prop({
    type: Object,
  })
  public readonly active!: Contact

  @Prop({
    type: Array,
    required: true,
  })
  public readonly contacts!: Contact[]

  public activeIndex = -1
  public currentContacts: Contact[] = []
  public filter = ''

  private router = Injector.get<VueRouter>(RouterToken)

  public emitContact(contact: Contact) {
    this.router.push({
      name: 'inbox',
      params: {
        organisation: contact ? String(contact.id) : '-1',
      },
    })
  }

  public handleKeyDown(keyDownEvent: KeyboardEvent) {
    if (keyDownEvent.key === Key.ArrowDown) {
      keyDownEvent.preventDefault()

      this.select(1)
    } else if (keyDownEvent.key === Key.ArrowUp) {
      keyDownEvent.preventDefault()

      this.select(-1)
    } else if (keyDownEvent.key === Key.Enter) {
      this.emitContact(this.currentContacts[this.activeIndex])

      this.updateFilter('')
    }
  }

  public updateContacts(contacts: Contact[] = this.contacts) {
    if (isNotBlank(this.filter)) {
      this.currentContacts = contacts.filter(
        contact => contact.name.toLowerCase().indexOf(this.filter) > -1
      )
    } else {
      this.currentContacts = contacts
    }
  }

  public updateFilter(filter = this.filter) {
    this.filter = filter.toLowerCase()

    if (isBlank(this.filter)) {
      this.activeIndex = -1
    } else {
      this.activeIndex = 0
    }

    this.updateContacts()
  }

  private select(diff: number) {
    const newIndex = this.activeIndex + diff

    if (newIndex > -1 && newIndex < this.currentContacts.length) {
      this.activeIndex = newIndex
    }
  }

  @Watch('contacts', {
    immediate: true,
  })
  private contactsChanged(contacts: Contact[]) {
    this.activeIndex = -1

    this.updateContacts(contacts)
  }
}
